import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import {
  Action,
  createAction,
  createFeatureSelector,
  createReducer,
  createSelector,
  on,
  props,
} from '@ngrx/store';
import { SessionEdition } from '../../_models/SessionEdition';
import { Account } from '../../_models/Account';

export const name = 'sessions';

export interface SessionEditionState extends EntityState<SessionEdition> {
  selectedId: number | null;
  isInitialized: boolean;
  isLoading: boolean;
}

function selectSession(a: SessionEdition): any {
  return a.id;
}

function sortByDate(a: SessionEdition, b: SessionEdition): number {
  if (a.dateDebut < b.dateDebut) {
    return -1;
  } else if (a.dateDebut > b.dateDebut) {
    return 1;
  } else {
    return 0;
  }
}

const adapter: EntityAdapter<SessionEdition> =
  createEntityAdapter<SessionEdition>({
    selectId: selectSession,
    sortComparer: sortByDate,
  });

const initialState: SessionEditionState = adapter.getInitialState({
  selectedId: null,
  isInitialized: false,
  isLoading: false,
});

/* ACTION */
export const loadSessionEditionAction = createAction(
  '[Session] Load SessionEdition'
);
export const loadSessionEditionSuccessAction = createAction(
  '[Session] Load SessionEdition Success',
  props<{ payload: SessionEdition[] }>()
);
export const loadSessionEditionErrorAction = createAction(
  '[Session] Load SessionEdition Error'
);
export const takeSessionEditionAction = createAction(
  '[Session] Take SessionEdition'
);
export const releaseSessionEditionAction = createAction(
  '[Session] Release SessionEdition'
);
export const setSessionEditionAction = createAction(
  '[Session] Update SessionEdition',
  props<{ payload: SessionEdition[] }>()
);

/* REDUCER */
const reducer = createReducer(
  initialState,
  on(loadSessionEditionAction, (state) => {
    return { ...state, isLoading: true };
  }),
  on(loadSessionEditionErrorAction, (state) => {
    return { ...state, isLoading: false };
  }),
  on(loadSessionEditionSuccessAction, (state, { payload }) => {
    return adapter.setAll(payload, {
      ...state,
      isInitialized: true,
      isLoading: false,
    });
  }),
  on(setSessionEditionAction, (state, { payload }) => {
    return adapter.setAll(payload, state);
  })
);

export function sessionReducer(
  state: SessionEditionState | undefined,
  action: Action
): SessionEditionState {
  return reducer(state, action);
}

/* SELECTOR */
const selectSessionState = createFeatureSelector<SessionEditionState>(name);

const isInitialized = (state: SessionEditionState) => state.isInitialized;
const isLoading = (state: SessionEditionState) => state.isLoading;

export const { selectIds, selectEntities, selectAll, selectTotal } =
  adapter.getSelectors();

export const getIsEditionSessionInitialized = createSelector(
  selectSessionState,
  isInitialized
);

export const selectAllSessions = createSelector(selectSessionState, (state) => {
  return state.isLoading
    ? undefined
    : state.ids.map((id: any) => state.entities[id]);
});

export const hasSessionEdition = (user: Account | undefined) =>
  createSelector(selectAllSessions, (sessions) => {
    console.debug('all sessions', sessions);
    return user == null || sessions == null
      ? undefined
      : sessions.find((x) => x && x.userId === user.nameId);
  });
  